module.exports = __webpack_public_path__ + "static/media/akward.19ff54bf.png";